
export const getTranslation = ({ translations }, keyName)=>
    translations.translations[keyName];
